!function() {
    "use strict";
    /* @preserve
   * https://github.com/Elkfox/Ajaxinate
   * Copyright (c) 2017 Elkfox Co Pty Ltd (elkfox.com)
   * MIT License (do not remove above copyright!)
   */
    function t(t) {
        const e = t || {};
        this.settings = Object.assign({
            method: "scroll",
            container: "#AjaxinateContainer",
            pagination: "#AjaxinatePagination",
            offset: 0,
            loadingText: "Loading",
            callback: null
        }, e),
        this.addScrollListeners = this.addScrollListeners.bind(this),
        this.addClickListener = this.addClickListener.bind(this),
        this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this),
        this.preventMultipleClicks = this.preventMultipleClicks.bind(this),
        this.removeClickListener = this.removeClickListener.bind(this),
        this.removeScrollListener = this.removeScrollListener.bind(this),
        this.removePaginationElement = this.removePaginationElement.bind(this),
        this.destroy = this.destroy.bind(this),
        this.containerElement = document.querySelector(this.settings.container),
        this.paginationElement = document.querySelector(this.settings.pagination),
        this.initialize()
    }
    t.prototype.initialize = function() {
        if (!this.containerElement)
            return;
        ({
            click: this.addClickListener,
            scroll: this.addScrollListeners
        })[this.settings.method]()
    }
    ,
    t.prototype.addScrollListeners = function() {
        this.paginationElement && (document.addEventListener("scroll", this.checkIfPaginationInView),
        window.addEventListener("resize", this.checkIfPaginationInView),
        window.addEventListener("orientationchange", this.checkIfPaginationInView))
    }
    ,
    t.prototype.addClickListener = function() {
        this.paginationElement && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
        this.clickActive = !0,
        void 0 !== this.nextPageLinkElement && null !== this.nextPageLinkElement && this.nextPageLinkElement.addEventListener("click", this.preventMultipleClicks))
    }
    ,
    t.prototype.preventMultipleClicks = function(t) {
        t.preventDefault(),
        this.clickActive && (this.nextPageLinkElement.innerText = this.settings.loadingText,
        this.nextPageUrl = this.nextPageLinkElement.href,
        this.clickActive = !1,
        this.loadMore())
    }
    ,
    t.prototype.checkIfPaginationInView = function() {
        const t = this.paginationElement.getBoundingClientRect().top - this.settings.offset
          , e = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
        t <= window.innerHeight && e >= 0 && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
        this.removeScrollListener(),
        this.nextPageLinkElement && (this.nextPageLinkElement.innerText = this.settings.loadingText,
        this.nextPageUrl = this.nextPageLinkElement.href,
        this.loadMore()))
    }
    ,
    t.prototype.loadMore = function() {
        this.request = new XMLHttpRequest,
        this.request.onreadystatechange = function() {
            if (!this.request.responseXML)
                return;
            if (4 === !this.request.readyState || 200 === !this.request.status)
                return;
            const t = this.request.responseXML.querySelectorAll(this.settings.container)[0]
              , e = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
            this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
            void 0 === e ? this.removePaginationElement() : (this.paginationElement.innerHTML = e.innerHTML,
            this.settings.callback && "function" == typeof this.settings.callback && this.settings.callback(this.request.responseXML),
            this.initialize())
        }
        .bind(this),
        this.request.open("GET", this.nextPageUrl),
        this.request.responseType = "document",
        this.request.send()
    }
    ,
    t.prototype.removeClickListener = function() {
        this.nextPageLinkElement.removeEventListener("click", this.preventMultipleClicks)
    }
    ,
    t.prototype.removePaginationElement = function() {
        this.paginationElement.innerHTML = "",
        this.destroy()
    }
    ,
    t.prototype.removeScrollListener = function() {
        document.removeEventListener("scroll", this.checkIfPaginationInView),
        window.removeEventListener("resize", this.checkIfPaginationInView),
        window.removeEventListener("orientationchange", this.checkIfPaginationInView)
    }
    ,
    t.prototype.destroy = function() {
        return {
            click: this.removeClickListener,
            scroll: this.removeScrollListener
        }[this.settings.method](),
        this
    }
    ,
    customElements.get("ajaxinate-items") || customElements.define("ajaxinate-items", class extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.init()
        }
        init() {
            this.ajaxinateContainer = this.querySelector("#AjaxinateLoop"),
            this.endlessScroll = null;
            const e = this.ajaxinateContainer?.dataset.ajaxinateId
              , i = `#AjaxinateLoop[data-ajaxinate-id="${e}"]`
              , n = `#AjaxinatePagination[data-ajaxinate-id="${e}"]`
              , s = this.ajaxinateContainer?.children.length > 0;
            if (this.loadMoreFix(),
            !s)
                return;
            this.endlessScroll = new t({
                container: i,
                pagination: n,
                method: "scroll"
            });
            const o = this.ajaxinateContainer.querySelectorAll("[data-promo]")
              , a = Number(this.ajaxinateContainer.getAttribute("data-columns-tablet"))
              , r = Number(this.ajaxinateContainer.getAttribute("data-columns-mobile"));
            if (a >= 3) {
                let t = 0;
                if (o.forEach((e => {
                    e.classList.contains("collection-promo--full") ? e.classList.contains("collection-promo--grid-third") ? t += 1 : e.classList.contains("collection-promo--grid-second") ? t += 2 : t += 3 : e.classList.contains("collection-promo--two-columns") ? e.classList.contains("collection-promo--grid-third") ? t += 1 : t += 2 : t += 1
                }
                )),
                t > 0) {
                    let e = a - t % a;
                    e === a && (e = 0),
                    this.ajaxinateContainer.classList.add(`grid--empty-items-tablet-${e}`)
                }
            }
            if (2 === r) {
                let t = 0;
                if (o.forEach((e => {
                    (e.classList.contains("collection-promo--grid-even") || e.classList.contains("collection-promo--one-column")) && (t += 1)
                }
                )),
                t > 0) {
                    let e = r - t % r;
                    e === r && (e = 0),
                    this.ajaxinateContainer.classList.add(`grid--empty-items-mobile-${e}`)
                }
            }
            this.ajaxinateContainer.classList.add("is-loaded")
        }
        reinit() {
            this.unload(),
            this.init()
        }
        loadMoreFix() {
            t.prototype.loadMore = function() {
                this.request = new XMLHttpRequest,
                this.request.onreadystatechange = function() {
                    if (!this.request.responseXML)
                        return;
                    if (4 === !this.request.readyState || 200 === !this.request.status)
                        return;
                    const t = this.request.responseXML.querySelector(this.settings.container)
                      , e = this.request.responseXML.querySelector(this.settings.pagination);
                    t.querySelectorAll("[data-product-block]").forEach((t => t.classList.add("loaded-item"))),
                    this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
                    null == e ? this.removePaginationElement() : (this.paginationElement.innerHTML = e.innerHTML,
                    this.settings.callback && "function" == typeof this.settings.callback && this.settings.callback(this.request.responseXML),
                    this.initialize());
                    if (typeof globoswatch != "undefined") {
                     globoswatch?.init();
                     }
                }
                .bind(this),
                this.request.open("GET", this.nextPageUrl, !0),
                this.request.responseType = "document",
                this.request.send()
            }
        }
        unload() {
            null !== this.endlessScroll && (this.endlessScroll.settings.method = "scroll",
            this.endlessScroll.destroy(),
            this.endlessScroll = null),
            this.ajaxinateContainer.classList.remove("is-loaded")
        }
        disconnectedCallback() {
            this.unload()
        }
    }
    )
}();
